export const isEmptyComment = commentText => {
  return !commentText
}

export const isValidComment = (commentText, domainConfig) => {
  const EMAIL_REGEX = domainConfig.get('REGEX_EMAIL')
  const NUMBERS_REGEX = domainConfig.get('REGEX_PHONE_NUMBERS_AND_HACKY_PHONE_VARIATIONS')
  const URLS_REGEX = domainConfig.get('REGEX_URLS')
  const CODE_REGEX = domainConfig.get('REGEX_CODE')

  return (
    !EMAIL_REGEX.test(commentText) &&
    !NUMBERS_REGEX.test(commentText) &&
    !URLS_REGEX.test(commentText) &&
    !CODE_REGEX.test(commentText)
  )
}
